import { t, Trans } from '@lingui/macro';
import React from 'react';
import SignupOption from './SignupOption';

interface Props {
    callbackFuntion: () => void;
    hideInstantPaymentOffersChecked?: boolean;
    trackVideoStartedEvent?: () => void;
}
export default function MoneyflowOnboardDialogContent({ callbackFuntion, hideInstantPaymentOffersChecked }: Props) {
    return (
        <div className="flex grow mb-16">
            <SignupOption
                className="pr-10 grow"
                title={t`Onboard in a few minutes today`}
                bulletPoints={[
                    t`Onboarding only takes a few minutes without leaving your workflow.`,
                    t`Instant payment is a free tool, pay only when you use.`,
                    t`No commitment, turn off any time.`,
                    t`You need NemID/MitID to signup with Moneyflow.`,
                ]}
                buttonTitle={t`Start now`}
                callbackFunction={callbackFuntion}
                hideInstantPaymentOffersChecked={hideInstantPaymentOffersChecked}
            />
            <div className="pl-10 flex grow w-1/2 flex-col">
                <div className="flex grow mb-4">
                    <iframe
                        className="w-full h-60"
                        src={t`https://www.youtube.com/embed/wLamXocd_VM`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
                <span>
                    <Trans>
                        With Instant Payment, you will receive your money in the account as soon as you have sent the invoice via
                        e-conomic.
                    </Trans>
                </span>
            </div>
        </div>
    );
}
